import React from "react";

const SuggestionIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.72496 0.705078C5.90645 5.22156 5.24291 5.89557 0.796875 6.72704C5.24295 7.55851 5.90645 8.23252 6.72496 12.749C7.54347 8.23252 8.20697 7.55851 12.653 6.72704C8.20697 5.89557 7.54343 5.22156 6.72496 0.705078Z"
        fill="#8762D6"
      />
      <path
        d="M11.9054 9.20215C11.4234 11.8621 11.0325 12.2591 8.41406 12.7487C11.0325 13.2384 11.4234 13.6354 11.9054 16.2953C12.3874 13.6354 12.7782 13.2384 15.3967 12.7487C12.7782 12.2591 12.3874 11.8621 11.9054 9.20215Z"
        fill="#8762D6"
      />
    </svg>
  );
};

export default SuggestionIcon;
